import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import MoneyFormatter from "../utils/money-formatter";
import OddsFormatter from "../utils/odds-formatter";
import Tracker from "../mobile-components/svg-tracker";

import * as I from "../utils/icons";
import CashoutService from "../../../services/cashout";
import Config from "../config";
import { CashoutOptionsTooltip } from "../desktop-components/autocashout-tooltip";
import Ticket from "../../../services/ticket";


export function CashoutTabsContainer({ children }) {
    return <nav class="p-2 bg-slate-100 flex gap-3">{children}</nav>
}

export function CashoutTab({ selected, onSwitchTab, name }) {
    return <a class={"cursor-pointer p-2 text-base h-full rounded-lg text-slate-950 " + (selected ? ' bg-slate-300' : ' bg-slate-200')} onClick={e => onSwitchTab()}>
        {name}
    </a>
}

export function BetsTable({ children }) {
    return <table class="w-full table-auto bg-slate-100 text-slate-950 text-center">
        {children}
    </table>;
}

export function BetsTableHeader({ children }) {
    return <thead class="text-center font-bold bg-slate-200 text-slate-950">
        {children}
    </thead>;
}
export function BetsHeadCell({ children }) {
    return <th class="px-2 py-1">
        {children}
    </th>;
}



export class TicketSummary extends Component {
    render({
        row,
        ticket,
        onIdClick,
        onCashoutRequest,
        isCashoutAllowed,
        cashoutAmountPreview,
        eventipresi,
        quotatotale,
        isTicketOpen,
        onToggleTicketBody,

        onAutoCashout,
        onPartialCashout,

        children
    }) {
        return <Fragment>
            <tr class="betstable-main-row align-middle">
                <td class=" bg-slate-300 text-slate-950">
                    <TicketPrintBtn onClick={() => onIdClick({ code: ticket.id, id: ticket.ticketId.toUpperCase() })}>
                        {ticket.ticketId.toUpperCase()} <I.PrinterIcon class="h-3 inline ml-3" />
                    </TicketPrintBtn>
                </td>
                <td class="leading-10 bg-slate-300 text-slate-950">
                    {!!row.live
                        ? <Trans>Live</Trans>
                        : <Trans>Prematch</Trans>}
                </td>
                <td class=" bg-slate-300 text-slate-950">
                    {!!isCashoutAllowed
                        ? <CashoutButton
                            onCashout={onCashoutRequest}
                            ticket={ticket}
                            canCashout={!!isCashoutAllowed}
                            cashoutAmount={cashoutAmountPreview} />
                        : <DisabledCashoutButton />}
                </td>
                <td class="relative">
                    <div class="flex items-center justify-center">
                        <div class="flex-shrink-0">
                            <MoneyFormatter value={row.betAmount} currency={row.currency} />
                            {/* Mostra l'icona degli sliders se il cashout parziale è abilitato, se il cashout è possibile e se l'importo della scommessa è maggiore o uguale all'importo minimo per il cashout parziale */}
                            {!!Config.partialcashout && row.betAmount >= Ticket.getMinBetAfterTax() && <a
                                href="javascript:void(0)"
                                class={"inline-block py-1 px-2 ml-2 text-sm rounded leading-5 button-minimal"}
                                title={window.Translation(msg`Partial Cashout`)}
                                onClick={e => {
                                    // Schifo. Va gestito comunque e messo nel "boundary" di auto-chiusura del componente più sotto.
                                    e.stopPropagation();
                                    this.setState({ showCashoutOptions: !this.state.showCashoutOptions });
                                }}
                            >
                                <i class="fas fa-sliders-h" />
                            </a>}
                            {/* Mostra il tooltip se showCashoutOptions è true */}
                            {this.state.showCashoutOptions && <CashoutOptionsTooltip
                                row={row}
                                ticket={ticket}
                                onClose={() => this.setState({ showCashoutOptions: false })}
                                onAutoCashout={onAutoCashout}
                                onPartialCashout={onPartialCashout}
                            />}
                        </div>
                        {row.autocashout && <div class="flex-shrink-0">
                            <div class="flex flex-col bg-red-600 text-white font-bold text-xs text-center gap-1 rounded w-10 p-1">
                                <span>Auto</span>
                            </div>
                        </div>}
                    </div>
                </td>
                <td class=" bg-slate-300 text-slate-950">
                    {parseInt(eventipresi) !== 0
                        ? <OddsVersusSettled total={row.odds.length} eventiPresi={eventipresi} />
                        : <OddsNumber>{row.odds.length}</OddsNumber>}
                </td>
                <td class="main-color font-bold bg-slate-300 text-slate-950">
                    <OddsFormatter odds={quotatotale} />
                </td>
                <td class="body-text-color text-center pr-6 bg-slate-300 text-slate-950">
                    <MoneyFormatter value={row.maxWinAmount} currency={row.currency} />
                </td>
                <td class=" bg-slate-300 text-slate-950">
                    <ToggleTicketButton isOpen={isTicketOpen} onToggle={onToggleTicketBody} />
                </td>
            </tr>
            {isTicketOpen && <tr>
                <td colSpan="8">
                    {children}
                </td>
            </tr>}
            <SpaceRow />
        </Fragment>;
    }
}

export function CashoutButton({ onCashout, ticket, canCashout, cashoutAmount }) {
    return <a class="py-1 px-4 text-xs font-bold rounded leading-5 cursor-pointer py-2 bg-kobaaccent-500 text-kobaaccent-950 hover:bg-kobaaccent-400" onClick={onCashout} >
        <MoneyFormatter value={cashoutAmount} curency={ticket.currency} />
    </a>
}
export function DisabledCashoutButton() {
    return <a class="py-1 px-4 text-xs font-bold rounded leading-5 cursor-pointer py-2 bg-red-600 text-red-50 disabled">
        <I.LockIcon class="h-4 inline" />
    </a>
}


export function TicketPrintBtn({ onClick, children }) {
    return <a class="betstable-print-button cursor-pointer" onClick={onClick}>
        {children}
    </a>
}

export function OddsNumber({ children }) {
    return <div class="inline">{children}</div>
}

export function OddsVersusSettled({ total, eventiPresi }) {
    return <div><span class="text-green-600 font-bold">{eventiPresi}</span> / <span>{total}</span></div>
}

export function ToggleTicketButton({ isOpen, onToggle }) {
    return <a class="block px-2 cursor-pointer" onClick={e => onToggle()}>
        <I.UpArrowIcon class={"h-3 transition-transform " + (isOpen ? "rotate-180" : '')} />
    </a>
}

export function TicketTable({ children }) {
    return <table class="w-full border-b-4 text-sm border-b border-b-slate-300">{children}</table>
}

export function TicketSelectionTemplate({ item, dateFormat, statusDescription, currentOdds, showLiveOdds, liveEvent }) {
    return <tr class="betstable-details-row">
        <td class="w-1/10 p-2 border-r border-r-slate-200 betstable-border-color">
            {dateFormat}
        </td>
        <td class="w-4/10 p-2 text-left border-r border-r-slate-200 betstable-border-color">
            <div class="flex items-center justify-center">
                <span class="w-full">
                    {item.name}
                </span>
                {!!liveEvent && <span class="flex-shrink-0 flex-grow-0 flex flex-col items-center justify-center text-center">
                    <span>{window.Translation(liveEvent.status.phase)}{!!liveEvent.status.timer ? ' - ' + liveEvent.status.timer + '\'' : ''}</span>
                    <span>{liveEvent.current.result.join(':')}</span>
                </span>}
                {!!liveEvent && <div class="flex-shrink-0 flex-grow-0 w-10 px-1 flex flex-col items-center [perspective:35px] will-change-transform">
                    <div class="[transform:rotateX(45deg)] will-change-transform w-full h-full">{false && <Tracker event={liveEvent} />}</div>
                </div>}
            </div>
        </td>
        <td class="w-3/10 p-2 text-left border-r betstable-border-color">{item.market} - {item.outcome}</td>
        <td class="w-1/10 p-2 font-bold border-r betstable-border-color">
            <div class="flex flex-row">
                <span class={"w-full" + (showLiveOdds ? ' body-text-color line-through font-normal' : ' main-color')}>
                    <OddsFormatter odds={item.value} />
                </span>
                {showLiveOdds && <span class="main-color w-full">
                    {!currentOdds ?
                        <I.LockIcon class="h-3" />
                        : <OddsFormatter odds={currentOdds} />}
                </span>}
            </div>
        </td>
        <td class="w-1/10 p-2">
            {!!item.status && <OutcomeStatusLabel item={item} statusDescription={statusDescription} />}
        </td>
    </tr>;
}

export function OutcomeStatusLabel({ statusDescription, item }) {
    return <div class="flex flex-row">
        <span class="w-full">{statusDescription}</span>
        <span
            class={'w-full text-right ' + (item.status === 'P' || item.status === 'L' ? 'text-red-600' : 'text-green-600')}>
            <i class={"fa " + (item.status === 'P' || item.status === 'L' ? 'fa-circle-xmark' : 'fa-check-circle')} />
        </span>
    </div>
}

export function SpaceRow() {
    return <tr>
        {/* Riga bianca di separazione fra le singole scommesse */}
        <td colspan="10" class="border-0 p-0">
            <div class="block w-full py-px" />
        </td>
    </tr>
}


